import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiKey, FiCopy, FiHome, FiLogOut, FiUsers, FiCalendar, FiSettings, FiCheckCircle, FiXCircle } from 'react-icons/fi';

const AdminInvitation = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [invitationLink, setInvitationLink] = useState('');
  const [invitations, setInvitations] = useState([]);
  const [formData, setFormData] = useState({
    duration: '12months',
    maxUses: 1
  });
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const loadInvitations = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/auth/invitations', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      if (data.invitations) {
        setInvitations(data.invitations);
      }
    } catch (error) {
      console.error('Error loading invitations:', error);
    }
  };

  useEffect(() => {
    loadInvitations();
  }, []);

  if (!user || user.role !== 'admin') {
    navigate('/admin/login');
    return null;
  }

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const generateInvitation = async () => {
    setLoading(true);
    setMessage('');
    
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/auth/generate-invitation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });
      
      const data = await response.json();
      
      if (data.registerLink) {
        setInvitationLink(data.registerLink);
        setMessage('邀请码生成成功！');
        setFormData({
          duration: '12months',
          maxUses: 1
        });
        loadInvitations();
      }
    } catch (error) {
      setMessage('生成邀请码失败，请重试。');
      console.error('Error generating invitation:', error);
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(invitationLink);
    setMessage('链接已复制到剪贴板！');
  };

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}/${month}/${day} ${hours}:${minutes}`;
  };

  const getDurationText = (duration) => {
    const durations = {
      '1month': '1个月',
      '3months': '3个月',
      '6months': '6个月',
      '12months': '12个月',
      'lifetime': '终身'
    };
    return durations[duration] || duration;
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f5f7fa' }}>
      {/* 导航栏 */}
      <nav style={{ 
        position: 'sticky', 
        top: 0, 
        zIndex: 1000, 
        backgroundColor: '#ffffff',
        padding: '12px 0',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
      }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 24px'
        }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '16px'
          }}>
            <img 
              src="/logo.png" 
              alt="123wonder英文科普" 
              style={{ 
                height: '50px', 
                width: 'auto'
              }} 
            />
            <div>
              <h1 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: '#333' }}>管理员后台</h1>
              <p style={{ margin: 0, fontSize: '13px', color: '#888' }}>邀请码管理</p>
            </div>
          </div>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            <button 
              onClick={() => navigate('/admin/manage')}
              style={{
                background: '#f8f9fa',
                border: '1px solid #e0e0e0',
                color: '#333',
                padding: '10px 18px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#e9ecef';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#f8f9fa';
              }}
            >
              管理文件
            </button>
            <button 
              onClick={() => navigate('/admin/upload')}
              style={{
                background: '#f8f9fa',
                border: '1px solid #e0e0e0',
                color: '#333',
                padding: '10px 18px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#e9ecef';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#f8f9fa';
              }}
            >
              上传文件
            </button>
            <span style={{ color: '#555', fontSize: '14px', marginRight: '8px' }}>欢迎，{user?.username}</span>
            <button 
              onClick={handleLogout}
              style={{
                background: '#f8f9fa',
                border: '1px solid #e0e0e0',
                color: '#333',
                padding: '10px 18px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#e9ecef';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#f8f9fa';
              }}
            >
              <FiLogOut /> 退出
            </button>
          </div>
        </div>
      </nav>

      <div style={{ padding: '24px 0' }}>
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 24px'
        }}>
          <button 
            onClick={() => navigate('/admin/manage')}
            style={{
              background: '#ffffff',
              border: '1px solid #e0e0e0',
              color: '#333',
              padding: '8px 14px',
              borderRadius: '6px',
              cursor: 'pointer',
              marginBottom: '20px',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '13px',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f8f9fa';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#ffffff';
            }}
          >
            <FiHome /> 返回管理页面
          </button>

          <div style={{ display: 'grid', gridTemplateColumns: '520px 1fr', gap: '24px' }}>
            {/* 生成邀请码表单 */}
            <div style={{ 
              backgroundColor: '#ffffff',
              borderRadius: '12px',
              padding: '28px',
              boxShadow: '0 2px 12px rgba(0, 0, 0, 0.04)'
            }}>
              <h2 style={{ 
                marginBottom: '24px',
                color: '#333',
                fontSize: '20px',
                fontWeight: '700',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <FiSettings /> 生成邀请码
              </h2>

              {message && (
                <div style={{ 
                  backgroundColor: message.includes('成功') || message.includes('已复制') ? '#e8f5e9' : '#ffebee',
                  color: message.includes('成功') || message.includes('已复制') ? '#2e7d32' : '#c62828',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  marginBottom: '20px',
                  fontSize: '14px'
                }}>
                  {message}
                </div>
              )}

              <form onSubmit={(e) => { e.preventDefault(); generateInvitation(); }}>
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ 
                    display: 'block', 
                    marginBottom: '8px',
                    color: '#333',
                    fontWeight: '600',
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}>
                    <FiCalendar /> 有效期
                  </label>
                  <select
                    name="duration"
                    value={formData.duration}
                    onChange={handleInputChange}
                    style={{
                      width: '100%',
                      padding: '12px 14px',
                      borderRadius: '8px',
                      border: '1px solid #e0e0e0',
                      fontSize: '14px',
                      color: '#333',
                      backgroundColor: '#ffffff',
                      height: '44px',
                      boxSizing: 'border-box',
                      outline: 'none',
                      transition: 'all 0.2s ease'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#1976d2';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e0e0e0';
                    }}
                  >
                    <option value="1month">1个月</option>
                    <option value="3months">3个月</option>
                    <option value="6months">6个月</option>
                    <option value="12months">12个月</option>
                    <option value="lifetime">终身</option>
                  </select>
                </div>

                <div style={{ marginBottom: '24px' }}>
                  <label style={{ 
                    display: 'block', 
                    marginBottom: '8px',
                    color: '#333',
                    fontWeight: '600',
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}>
                    <FiUsers /> 使用次数限制
                  </label>
                  <input
                    type="number"
                    name="maxUses"
                    value={formData.maxUses}
                    onChange={handleInputChange}
                    style={{
                      width: '100%',
                      padding: '12px 14px',
                      borderRadius: '8px',
                      border: '1px solid #e0e0e0',
                      fontSize: '14px',
                      color: '#333',
                      backgroundColor: '#ffffff',
                      height: '44px',
                      boxSizing: 'border-box',
                      outline: 'none',
                      transition: 'all 0.2s ease'
                    }}
                    placeholder="请输入使用次数"
                    min="1"
                    max="100"
                    onFocus={(e) => {
                      e.target.style.borderColor = '#1976d2';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e0e0e0';
                    }}
                  />
                </div>

                <button
                  type="button"
                  onClick={generateInvitation}
                  disabled={loading}
                  style={{
                    width: '100%',
                    background: '#1976d2',
                    border: 'none',
                    color: 'white',
                    padding: '14px 24px',
                    borderRadius: '8px',
                    fontSize: '15px',
                    fontWeight: '600',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    transition: 'all 0.2s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}
                  onMouseEnter={(e) => {
                    if (!loading) {
                      e.target.style.backgroundColor = '#1565c0';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!loading) {
                      e.target.style.backgroundColor = '#1976d2';
                    }
                  }}
                >
                  <FiKey /> {loading ? '生成中...' : '生成邀请码'}
                </button>
              </form>

              {invitationLink && (
                <div style={{ 
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #e9ecef',
                  borderRadius: '8px',
                  padding: '16px',
                  marginTop: '20px'
                }}>
                  <p style={{ 
                    margin: 0,
                    color: '#666',
                    fontSize: '13px',
                    wordBreak: 'break-all'
                  }}>
                    {invitationLink}
                  </p>
                </div>
              )}
            </div>

            {/* 邀请码列表 */}
            <div style={{ 
              backgroundColor: '#ffffff',
              borderRadius: '12px',
              padding: '28px',
              boxShadow: '0 2px 12px rgba(0, 0, 0, 0.04)'
            }}>
              <div style={{ 
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '24px'
              }}>
                <h2 style={{ 
                  margin: 0,
                  color: '#333',
                  fontSize: '20px',
                  fontWeight: '700',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <FiUsers /> 邀请码列表
                </h2>
                <button 
                  onClick={() => navigate('/admin/users')}
                  style={{
                    background: '#1976d2',
                    border: 'none',
                    color: 'white',
                    padding: '10px 18px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#1565c0';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#1976d2';
                  }}
                >
                  <FiUsers /> 查看用户列表
                </button>
              </div>

              <div style={{ overflowX: 'auto' }}>
                <table style={{ 
                  width: '100%', 
                  borderCollapse: 'collapse',
                  fontSize: '13px'
                }}>
                  <thead>
                    <tr style={{ backgroundColor: '#f5f7fa' }}>
                      <th style={{ 
                        padding: '12px 14px', 
                        textAlign: 'left', 
                        borderBottom: '2px solid #e8eaed',
                        fontWeight: '600',
                        color: '#333',
                        fontSize: '13px'
                      }}>邀请码</th>
                      <th style={{ 
                        padding: '12px 14px', 
                        textAlign: 'left', 
                        borderBottom: '2px solid #e8eaed',
                        fontWeight: '600',
                        color: '#333',
                        fontSize: '13px'
                      }}>有效期</th>
                      <th style={{ 
                        padding: '12px 14px', 
                        textAlign: 'center', 
                        borderBottom: '2px solid #e8eaed',
                        fontWeight: '600',
                        color: '#333',
                        fontSize: '13px'
                      }}>使用情况</th>
                      <th style={{ 
                        padding: '12px 14px', 
                        textAlign: 'left', 
                        borderBottom: '2px solid #e8eaed',
                        fontWeight: '600',
                        color: '#333',
                        fontSize: '13px'
                      }}>已使用手机号</th>
                      <th style={{ 
                        padding: '12px 14px', 
                        textAlign: 'left', 
                        borderBottom: '2px solid #e8eaed',
                        fontWeight: '600',
                        color: '#333',
                        fontSize: '13px'
                      }}>创建时间</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invitations.length === 0 ? (
                      <tr>
                        <td colSpan={5} style={{ 
                          padding: '40px 20px', 
                          textAlign: 'center', 
                          color: '#888',
                          fontSize: '14px'
                        }}>
                          暂无邀请码记录
                        </td>
                      </tr>
                    ) : (
                      invitations.map((invitation) => (
                        <tr key={invitation._id} style={{ 
                          borderBottom: '1px solid #f0f0f0',
                          transition: 'background-color 0.2s ease'
                        }} 
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                        >
                          <td style={{ padding: '12px 14px' }}>
                            <div style={{ fontWeight: '600', color: '#333', fontFamily: 'monospace', fontSize: '14px' }}>
                              {invitation.code}
                            </div>
                          </td>
                          <td style={{ padding: '12px 14px', color: '#555' }}>
                            {getDurationText(invitation.duration)}
                          </td>
                          <td style={{ padding: '12px 14px', textAlign: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                              <span style={{ color: '#333', fontWeight: '600', fontSize: '14px' }}>
                                {invitation.usedPhones?.length || 0} / {invitation.maxUses || 1}
                              </span>
                              {invitation.usedPhones?.length >= (invitation.maxUses || 1) && (
                                <span style={{ 
                                  color: '#fff', 
                                  fontSize: '12px', 
                                  backgroundColor: '#e74c3c',
                                  padding: '4px 10px',
                                  borderRadius: '4px',
                                  fontWeight: '500'
                                }}>
                                  已达上限
                                </span>
                              )}
                            </div>
                          </td>
                          <td style={{ padding: '12px 14px' }}>
                            <div style={{ color: '#555', fontSize: '13px' }}>
                              {invitation.usedPhones?.length > 0 ? (
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                  {invitation.usedPhones.map((phone, idx) => (
                                    <span key={idx} style={{ 
                                      backgroundColor: '#e3f2fd',
                                      color: '#1976d2',
                                      padding: '4px 10px',
                                      borderRadius: '4px',
                                      fontWeight: '500'
                                    }}>
                                      {phone}
                                    </span>
                                  ))}
                                </div>
                              ) : (
                                <span style={{ color: '#aaa' }}>-</span>
                              )}
                            </div>
                          </td>
                          <td style={{ padding: '12px 14px', color: '#777', fontSize: '13px' }}>
                            {formatDate(invitation.createdAt)}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminInvitation;
